var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wap_companty_con"},_vm._l((_vm.$t('WapIndexIntr1.wappictures')),function(i,index){return _c('div',{key:index,staticClass:"con_item",on:{"click":function($event){return _vm.goCompany(i.name)}}},[_c('img',{attrs:{"src":i.img,"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }